
export class CartSummary {
  public CartItems: CartItem[];
  public CartOptions: any[]; //tax, upcharge and etc
  public CartItemsSubTotal: number = 0; //don't include in saving to db
  public GrandTotal: number = 0; //don't include in saving to db

  //options // don't include in saving to db
  public TotalTaxes: number = 0;
  public TotalxMofiers: number = 0;
  public TotalDiscounts: number = 0;
  public AggregatedOptions: OptionsCalcTotals[];
  public GeneralAdjustMents: any[];
}

export class ItemOptions {
  public ItemTaxes: any[];
  public ItemDiscounts: any[];
  public ItemUpcharges: any[];
  public ItemModifierSetOptions: any[];
}
//@TODO : Transfer the lineItemId or Id in this level and not on the Item
export class CartItem {
  public Item: Item = new Item();
  public ItemVariationId: number = 0;
  public Qty: number;
  public Notes: string = '';
  public Price: number = 0; //SubTotal of Item
}

export class ServiceItem {
  public ServiceId: number;
  public ServiceName: string;
  public Price: number;
  public CategoryName: string;
  public ServiceDescription: string;
}

export class Item {
  public Id: string;
  public ItemId: number = 0;
  public VariationId: number = 0;

  public ItemName: string;
  public ItemVariantName: string;
  public ProductName: string;
  public Barcode: string;
  public Photo: string;
  public Thumbnail: string;
  public CurrentQty: number = 0;
  public RecentPrice: number = 0;
  //calculation / processed based
  public ItemOptions: ItemOptions; // display only, don't use on aggregation or calculation
  public ItemOptionsCalc: OptionCalc[];
  public ItemOptionsSummarized: OptionsCalcTotals[];
  public ItemOptionsSubTotal: number = 0;

  //general discounts calculation
  public DiscountPercent: number = 0;
  public DiscountAmount: number = 0;
}

export class OptionCalc {
  public name: string;
  public type: string;
  public operation: string;
  public isPercent: boolean;
  public value: any;
}

export class OptionsCalcTotals {
  public type: string;
  public totalValue: number;
}
